import script from "./GamesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesPage.vue?vue&type=script&setup=true&lang=js"

import "./GamesPage.vue?vue&type=style&index=0&id=2405b9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2405b9fa"]])

export default __exports__